import { css } from '@emotion/react';

export default (theme) => css`
  font-size: ${theme.font.size.main};
  max-width: 1440px;
  margin: auto;
  position: relative;
  padding: 90px 70px;
  @media ${theme.media.phone} {
    padding: 24px 0;
    .input-lg {
      height: 48px;
      padding: 0 8px;
    }
    .btn-lg {
      height: 48px;
      padding: 0 16px;
    }
  }
`;
